import React from "react";
import { Helmet } from "react-helmet";
const ContactHelmet = ({ title }) => {
  return (
    <Helmet>
      
      <title>
        Contact | Digious Solutions | Leading IT & Digital Experts
      </title>
      <meta
        name="description"
        content="Ready to grow your business? Call (913) 374-5577 or contact Digious Solutions today. Our experts deliver web, app, and digital solutions that drive results."
      />
    </Helmet>
  );
};

export default ContactHelmet;
